import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateMultiSelectContent } from "./logic/content";

export const MODULE_TYPE = "multiSelect";
export type TYPE = "multiSelect";

export { transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateMultiSelectContent)
    .getModuleAssets(getModuleAssets)
    .back.staticInformation()
    .displayName("Multi Select")
    .testOnly()
    .supportsAmeliaExplainMyAnswer()
    .root.register();
